import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    lookUp() {
        const btn = document.getElementById("hidden-look-up-btn");
        btn.click();
    }
}
